// src/theme/themeHooks.js
import { useTheme } from '@mui/material/styles';

/**
 * Custom hooks for accessing theme tokens and helpers
 */

export const useThemeTokens = () => {
  const theme = useTheme();
  
  return {
    // Easy access to tokens
    tokens: theme.aghrba.tokens,
    typography: theme.aghrba.typography,
    effects: theme.aghrba.effects,
    gradients: theme.aghrba.gradients,
    animations: theme.aghrba.animations,
    
    // Helper functions
    applyGradient: (type) => theme.aghrba.gradients[type],
    applyEffect: (type) => theme.aghrba.effects[type],
    applyAnimation: (type) => theme.aghrba.animations[type],
    
    // Component style helpers
    getCardStyle: (variant = 'standard') => ({
      ...theme.aghrba.tokens.cardStyles[variant],
    }),
    
    getButtonStyle: (size = 'medium', isGlowing = false) => ({
      ...theme.aghrba.tokens.buttonStyles.sizes[size],
      ...(isGlowing && {
        animation: theme.aghrba.animations.glow,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
          transition: 'left 0.7s',
        },
        '&:hover::before': {
          left: '100%',
        },
      }),
    }),
    
    getTextFieldStyle: (size = 'medium') => ({
      ...theme.aghrba.tokens.textFieldStyles.sizes[size],
    }),
  };
};

// Hook for applying gradient text
export const useGradientText = () => {
  const theme = useTheme();
  
  return {
    style: theme.aghrba.typography.gradientText(theme),
    className: 'gradient-text',
  };
};

// Hook for applying magical effects
export const useMagicalEffect = (type = 'glow') => {
  const theme = useTheme();
  
  const effects = {
    glow: {
      animation: theme.aghrba.animations.glow,
      boxShadow: theme.aghrba.effects.cardGlow,
    },
    float: {
      animation: theme.aghrba.animations.float,
    },
    shine: {
      animation: theme.aghrba.animations.shine,
      background: 'linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.1) 50%, transparent 55%)',
      backgroundSize: '200% 200%',
    },
  };
  
  return effects[type] || {};
};